import Progress from "@visa/vds/progress";
import React from "react";

const MCSProgressMessage = (props) => {
  return (
    <div style={{ display: "flex" }}>
      <Progress type="spinner" size="small" />
      <span style={{ margin: "1rem" }}>{props.message}</span>
    </div>
  );
};

export default MCSProgressMessage;
